import type { UserSessionEntry, UserUsageEntry } from "./types";

interface Accumulator {
  sessionCount: number;
  experiences: Set<string>;
  totalDurationSeconds: number;
}

export const aggregateUserUsage = (sessions: UserSessionEntry[]): UserUsageEntry[] => {
  const byUser = new Map<string, Accumulator>();

  for (const session of sessions) {
    let acc = byUser.get(session.userId);

    if (!acc) {
      acc = { sessionCount: 0, experiences: new Set(), totalDurationSeconds: 0 };
      byUser.set(session.userId, acc);
    }

    acc.sessionCount += 1;
    acc.experiences.add(session.experienceName);
    acc.totalDurationSeconds += session.durationSeconds;
  }

  return Array.from(byUser, ([userId, acc]) => ({
    id: userId,
    userId,
    sessionCount: acc.sessionCount,
    uniqueExperienceCount: acc.experiences.size,
    totalDurationSeconds: acc.totalDurationSeconds,
  }));
};
